import React, { useState } from "react";
import AddSkills from "./AddSkills";

/* SAME OPTIONS YOU SHARED EARLIER */
const skillOptions = [
  { value: "13", label: "Director" },
  { value: "12", label: "Livestream Audio" },
  { value: "2", label: "Video Event" },
  { value: "3", label: "Video Music" },
  { value: "4", label: "Video Lifestyle" },
  { value: "5", label: "Photo Portrait" },
  { value: "6", label: "Photo Product" },
  { value: "7", label: "Photo Event" },
  { value: "8", label: "Photo Lifestyle" },
  { value: "9", label: "Audio Engineer" },
  { value: "10", label: "Creative Director" },
  { value: "11", label: "Livestream Director" },
  { value: "1", label: "Video Commercial" },
  { value: "14", label: "Video Weddings" },
  { value: "15", label: "Photo Weddings" },
  { value: "16", label: "Portrait Photo" },
  { value: "17", label: "Cinematographer" },
];

const SkillsForm = ({ value = [], onChange }) => {
  const [localSkills, setLocalSkills] = useState(value);

  return (
    <AddSkills
      value={localSkills}
      options={skillOptions}
      onChange={(skills) => {
        setLocalSkills(skills);
        onChange?.(skills);
      }}
    />
  );
};

export default SkillsForm;
